import { useState, useEffect } from 'react';
import lessonApi from 'Api/axios/lesson-api';
import { useHistory } from 'react-router-dom';

const useFetch = ({ lessonId, courseId }) => {
  const history = useHistory();
  const [alreadyAnswered, setAlreadyAnswered] = useState(null);
  const [loadingCheck, setLoadingCheck] = useState(true);

  useEffect(() => {
    lessonApi.checkIfUserHasAlreadyTakenTheTest(lessonId).then(response => {
      setAlreadyAnswered(response.data);
      setLoadingCheck(false);
    });
  }, [lessonId]);

  const startTest = () => {
    history.push({
      pathname: `/cursos/examen/${lessonId}`,
    });
  };

  return {
    startTest,
    alreadyAnswered,
    loadingCheck,
  };
};

export default useFetch;
